import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Optional,
  ViewChild,
} from '@angular/core';
import {DomIoService} from '@maia/core';

import {TableComponent} from '../table/table.component';

/**
 * Table header. The header must be placed inside a table. If the header is less wide than the table
 * itself, a padding will be added on the right side to make the width match.
 *
 * @ngModule TablesModule
 */
@Component({
  selector: 'maia-table-footer',
  templateUrl: './table-footer.component.html',
  styleUrls: ['./table-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableFooterComponent implements AfterViewInit {
  private readonly _table: TableComponent;

  @ViewChild('footer', {static: true})
  private readonly _footer: ElementRef;

  public constructor(
    private readonly _footerHost: ElementRef,
    private readonly _domIoService: DomIoService,
    @Optional() table?: TableComponent,
  ) {
    if (table == null) {
      throw new Error(
        'Cannot create a <maia-table-footer /> component out of <maia-table /> component',
      );
    }

    this._table = table;
  }

  public ngAfterViewInit() {
    this._changeWidth(this._table.width);
  }

  /**
   * Makes sure that the footer is at least as wide as the table itself.
   */
  private _changeWidth(tableWidth: number) {
    if (!tableWidth) {
      return;
    }
    let footerWidth: number;

    this._domIoService.measure(() => {
      footerWidth = this._footerHost.nativeElement.offsetWidth;
    });

    this._domIoService.mutate(() => {
      // Update the padding to make the footer width match the table height
      if (tableWidth < footerWidth) {
        (this._footer.nativeElement as HTMLElement).style.paddingRight = `${
          footerWidth - tableWidth
        }px`;
      } else {
        // @ts-expect-error
        (this._footer.nativeElement as HTMLElement).style.paddingRight = null;
      }
    });
  }
}
